var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCamera48Filled = function SvgIconCamera48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 28.8a3.3 3.3 0 1 0 0-6.6 3.3 3.3 0 0 0 0 6.6Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4 15.3H32l-1.45-2.43A5.36 5.36 0 0 0 26 10.3h-4a5.361 5.361 0 0 0-4.55 2.57L16 15.3h-2.4a5.31 5.31 0 0 0-5.3 5.3v11.8a5.31 5.31 0 0 0 5.3 5.3h20.8a5.31 5.31 0 0 0 5.3-5.3V20.6a5.31 5.31 0 0 0-5.3-5.3ZM24 32.2a6.7 6.7 0 1 1 6.7-6.7 6.71 6.71 0 0 1-6.7 6.7Zm10.7-9.5a1.7 1.7 0 1 1 0-2.4 1.68 1.68 0 0 1 0 2.4Z",
    fill: "current"
  })));
};
export default SvgIconCamera48Filled;